import { getApiClientWithAccessToken } from "../libs/ApiClient";
import {
  Account,
  AccountList,
} from "../features/AccountSelector/services/getAccountList";

export async function isUserHasAccount(accessToken: string): Promise<boolean> {
  try {
    const client = getApiClientWithAccessToken(accessToken);
    const accounts: Account[] = (await client.get<AccountList>(`/accounts/v2`))
      .data.accounts;
    return accounts.length > 0;
  } catch (e) {
    return false;
  }
}
